import { Routes, Route } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { supabase, isConfigured } from './lib/supabase'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import MovieDetail from './pages/MovieDetail'
import GenrePage from './pages/GenrePage'
import SearchResults from './pages/SearchResults'
import Auth from './pages/Auth'
import Profile from './pages/Profile'
import Watchlist from './pages/Watchlist'
import Favorites from './pages/Favorites'
import History from './pages/History'
import Trending from './pages/Trending'
import NotFound from './pages/NotFound'

export default function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!isConfigured || !supabase) {
      setLoading(false)
      return
    }
    try {
      supabase.auth.getSession().then(({ data: { session } }) => {
        setSession(session)
        setLoading(false)
      }).catch(() => setLoading(false))
    } catch {
      setLoading(false)
    }
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark-900">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-400 text-sm">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header session={session} />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home session={session} />} />
          <Route path="/movie/:slug" element={<MovieDetail session={session} />} />
          <Route path="/genre/:slug" element={<GenrePage />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/auth" element={<Auth session={session} />} />
          <Route path="/profile" element={<Profile session={session} />} />
          <Route path="/watchlist" element={<Watchlist session={session} />} />
          <Route path="/favorites" element={<Favorites session={session} />} />
          <Route path="/history" element={<History session={session} />} />
          <Route path="/trending" element={<Trending />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}
